import React, { useEffect } from "react";
import { ErrorViewStyle as S } from "./ErrorView.style";
import { useNavigate } from "react-router-dom";
import { PButton } from "@prime/PButton/PButton";
import { MatIcon } from "components/MatIcon/MatIcon";
import { getApiService } from "services/api";

export const ErrorView: React.FC<{
  errorCode?: number;
  title?: string;
  summary?: string;
  eventId?: string;
  navigateBackTo?: string;
  resetState?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error?: any;
  showHomeButton?: boolean;
}> = ({
  errorCode,
  title,
  summary,
  error,
  eventId,
  navigateBackTo,
  resetState = false,
  showHomeButton = false,
}) => {
  const navigate = useNavigate();
  useEffect(() => {
    !window.location.origin.includes("localhost") &&
      getApiService()
        .apiCall$(
          "/api/Logger",
          "POST",
          {},
          {
            eventId: eventId ?? "n/a",
            url: window.location.pathname + window.location.search,
            message: JSON.stringify(error) ?? "Unknown error",
          },
          {
            noAuth: window.location.pathname.startsWith("/auth"),
          },
        )
        .subscribe();
  }, []);
  summary = summary ?? "We are experiencing some difficulties with our server. Please try again later.";
  return (
    <S.ErrorView key={summary?.length}>
      <div>
        <S.Small>Error code: {errorCode || 500}</S.Small>
        <h1>{title ?? "Sorry, something went wrong on our end."}</h1>
        <p>
          <span>{summary}</span>
          <br />
          <br />
          <span>If the issue persists, feel free to contact us at </span>
          <a href="mailto: support@goideally.com">support@goideally.com</a>.
        </p>
      </div>
      <S.Buttons>
        <PButton
          onClick={() => {
            resetState && localStorage.clear();
            navigateBackTo ? (window.location.href = navigateBackTo) : navigate(-1);
          }}
          icon={<MatIcon>west</MatIcon>}
          label="Go back"
        />
        {showHomeButton && (
          <PButton
            onClick={() => {
              window.location.href = "/";
            }}
            icon={<MatIcon>west</MatIcon>}
            label="Go to home"
          />
        )}
      </S.Buttons>
    </S.ErrorView>
  );
};
